export default __webpack_public_path__ + "static/media/image3.b778cb49.jpg";